import React, { useState, useEffect } from "react";
import { TextField, Card, CardContent } from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);

  // Function to fetch roles from the API
  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList", {
        /* request payload if needed */
      });
      setRoles(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const [updatebtn, setUpdateBtn] = useState(true);

  const navigate = useNavigate();
  //let userName ="";
  const handleClose = () => {
    navigate("../", { replace: true });
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getUserData = async () => {
    try {
      const response = await apiClient.post("/getUserData", {
        uname: logineuname,
        userName1: username,
        /* request payload if needed */
      });
      const data = response.data[0];
      setEmail(data.emailid);
      setMobileNumber(data.mobilenumber);
      setfName(data.FullName);
      setRole(data.userrights);
      setconsignee(data.consignee);
      setPassword("");
      setUpdateBtn(false);
    } catch (error) {
      setfName("");
      setEmail("");
      setPassword("");
      setMobileNumber("");
      setUpdateBtn(true);
      if (error.response) {
        // Server responded with a status other than 200 range
        // console.log('Error data:', error.response.data);
        //console.log('Error status:', error.response.status);
        // console.log('Error headers:', error.response.headers);
      } else if (error.request) {
        // No response received
        // console.log('No response:', error.request);
      } else {
        // Request setup triggered an Error
        // console.log('Error', error.message);
      }
      // console.log(error.config);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setconsignee(consignees[0].ConsigneeCode);
    }

    if (roles.length > 0) {
      setRole(roles[2].id);
    }
  }, [consignees, roles, username]);

  useEffect(() => {}, [updatebtn]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setMobileNumber(value);
    }
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const UpdatOldUser = async (e) => {
    e.preventDefault();

    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";

    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }

    setErrors(formErrors);

    //console.log(username);

    if (Object.keys(formErrors).length === 0) {
      apiClient
        .post("/changepassword", {
          uname: username,
          pastext: password,
          ipp: ip,
        })
        .then(function (response) {
          setErrors(response.data);

          setfName("");
          setEmail("");
          setPassword("");
          setUsername("");
          setPassword("");
          setMobileNumber("");
          //   if (roles.length > 0) {
          //     setRole(roles[2].role);
          //   }
        })
        .catch(function (error) {
          setErrors(error.data);
        });
    }
  };

 return (
  <>
    <style>{`
      .reset-password-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        overflow-x: hidden;
        background: #f4f8fc;
      }

      .reset-password-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin: 0 auto;
        border-radius: 16px !important;
        border: 1px solid #dbe7f3;
        background: #ffffff !important;
        box-shadow: 0 6px 22px rgba(13, 71, 161, 0.10) !important;
        overflow: hidden;
      }

      .reset-password-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0.2px;
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .reset-password-header::before {
        content: "🔐";
        font-size: 20px;
      }

      .reset-password-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 22px;
      }

      .reset-password-form {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .reset-password-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 16px;
        margin-bottom: 18px;
        border: 1px solid #e0eaf5;
        border-radius: 12px;
        background: #fbfdff;
      }

      .reset-password-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dce8f5;
        color: #0d47a1;
        font-size: 15px;
        font-weight: 700;
      }

      .reset-password-section-title::before {
        content: "";
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: linear-gradient(
          180deg,
          #0d47a1,
          #1976d2
        );
      }

      .reset-password-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      .reset-password-field {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .reset-password-field .MuiFormControl-root {
        width: 100%;
        max-width: 100%;
      }

      .reset-password-field .MuiInputBase-root {
        background: #ffffff;
      }

      .reset-password-field .MuiOutlinedInput-root:hover fieldset {
        border-color: #1976d2;
      }

      .reset-password-field .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #1565c0;
        border-width: 2px;
      }

      .reset-password-actions {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 14px;
        margin-top: 8px;
      }

      .reset-password-button {
        width: 100%;
        min-width: 0;
        min-height: 44px;
        border: none;
        border-radius: 9px;
        padding: 10px 18px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        box-sizing: border-box;
      }

      .reset-password-button:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
      }

      .reset-password-button:active:not(:disabled) {
        transform: translateY(0);
      }

      .reset-password-button:disabled {
        opacity: 0.55;
        cursor: not-allowed;
      }

      .reset-password-reset-btn {
        color: #ffffff;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
        box-shadow: 0 3px 8px rgba(13, 71, 161, 0.22);
      }

      .reset-password-close-btn {
        color: #ffffff;
        background: linear-gradient(
          135deg,
          #c62828,
          #e53935
        );
        box-shadow: 0 3px 8px rgba(198, 40, 40, 0.18);
      }

      @media (max-width: 900px) {
        .reset-password-content {
          padding: 18px;
        }

        .reset-password-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 13px;
        }
      }

      @media (max-width: 650px) {
        .reset-password-page {
          padding: 8px;
        }

        .reset-password-card {
          border-radius: 12px !important;
        }

        .reset-password-header {
          padding: 13px 15px;
          font-size: 16px;
        }

        .reset-password-content {
          padding: 12px;
        }

        .reset-password-section {
          padding: 12px;
          margin-bottom: 14px;
        }

        .reset-password-grid {
          grid-template-columns: minmax(0, 1fr);
          gap: 13px;
        }

        .reset-password-actions {
          grid-template-columns: minmax(0, 1fr);
          gap: 10px;
        }

        .reset-password-button {
          min-height: 46px;
        }
      }

      @media (max-width: 380px) {
        .reset-password-page {
          padding: 5px;
        }

        .reset-password-content {
          padding: 9px;
        }

        .reset-password-section {
          padding: 10px;
        }

        .reset-password-header {
          font-size: 15px;
        }
      }
    `}</style>

    <div className="reset-password-page">
      <Card className="reset-password-card">
        <div className="reset-password-header">
          Reset User Password
        </div>

        <CardContent className="reset-password-content">
          <div className="reset-password-form">

            {/* User Information */}
            <div className="reset-password-section">
              <div className="reset-password-section-title">
                User Information
              </div>

              <div className="reset-password-grid">

                {/* User ID */}
                <div className="reset-password-field">
                  <TextField
                    label="User ID"
                    size="small"
                    variant="outlined"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getUserData();
                      }
                    }}
                    fullWidth
                    error={!!errors.username}
                    helperText={errors.username}
                    inputProps={{ maxLength: 10 }}
                  />
                </div>

                {/* Email */}
                <div className="reset-password-field">
                  <TextField
                    label="Email"
                    size="small"
                    variant="outlined"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    error={!!errors.email}
                    helperText={errors.email}
                    inputProps={{ maxLength: 50 }}
                    disabled={true}
                  />
                </div>

                {/* Full Name */}
                <div className="reset-password-field">
                  <TextField
                    label="Full Name"
                    size="small"
                    variant="outlined"
                    value={fname}
                    onChange={(e) => setfName(e.target.value)}
                    fullWidth
                    error={!!errors.fname}
                    helperText={errors.fname}
                    inputProps={{ maxLength: 30 }}
                    disabled={true}
                  />
                </div>

                {/* Password */}
                <div className="reset-password-field">
                  <TextField
                    label="New Password"
                    variant="outlined"
                    size="small"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    error={!!errors.password}
                    helperText={errors.password}
                    inputProps={{ maxLength: 15 }}
                  />
                </div>

                {/* Mobile */}
                <div className="reset-password-field">
                  <TextField
                    label="Mobile Number"
                    variant="outlined"
                    type="tel"
                    size="small"
                    value={mobileNumber}
                    onChange={handleMobileNumberChange}
                    fullWidth
                    error={!!errors.mobileNumber}
                    helperText={errors.mobileNumber}
                    inputProps={{
                      maxLength: 10,
                      pattern: "[0-9]*",
                    }}
                    disabled={true}
                  />
                </div>

                {/* Role */}
                <div className="reset-password-field">
                  <DropdownfromDatabaseList
                    Options={roles}
                    option={role}
                    setOptionValue={setRole}
                    DisplayItem1="role"
                    DisplayItem2="id"
                    size="small"
                    disabled={true}
                  />
                </div>

              </div>
            </div>

            {/* Consignee */}
            {role === 2 && (
              <div className="reset-password-section">
                <div className="reset-password-section-title">
                  Consignee Information
                </div>

                <div className="reset-password-field">
                  <DropdownfromDatabaseList
                    Options={consignees}
                    size="small"
                    option={consignee}
                    setOptionValue={setconsignee}
                    DisplayItem1="Shop"
                    DisplayItem2="ConsigneeCode"
                    showKeyInLabel={true}
                    disabled={true}
                  />
                </div>
              </div>
            )}

            {/* Actions */}
            <div className="reset-password-actions">

              <button
                className="reset-password-button reset-password-reset-btn"
                type="button"
                onClick={UpdatOldUser}
                title="Reset user password"
                disabled={updatebtn}
              >
                🔑 Reset Password
              </button>

              <button
                className="reset-password-button reset-password-close-btn"
                type="button"
                onClick={handleClose}
                title="Close"
              >
                ✕ Close
              </button>

            </div>

          </div>
        </CardContent>
      </Card>
    </div>
  </>
);
}

export default ResetPassword;
